import { StyleSheet } from 'react-native';
export const styles = StyleSheet.create({
  toastWrapper: {
    position: 'absolute',
    zIndex: 99999,
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
  },
  toastWrapperDesktop: {
    right: 16,
    bottom: 76,
  },
});
